module.exports = __webpack_public_path__ + "img/prodigal_mobile_poster.208f9e17.png";